<template>
  <div>
     <center>
    <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
      </v-container>

      วิธีการใช้ ระบบ HRM ในการเช็คอิน-เช็คเอ้าท์
     </center>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date

export default {
  components: {
    name: 'Info',
    moment
  },
  data () {
    return {
      value: 1,
      PK: '',
      path: '/emp_issue/', // Path Model
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      valid_edit: true,
      session: this.$session.getAll(),
      formAdd: {
        empIssueInfoId: '',
        empIssueInfoTopic: '',
        empIssueInfoDetail: '',
        empCode: '',
        userName: '',
        STATUS: 'รอดำเนินการ'
      },
      dataInfo: [],
      formUpdate: {
        empIssueInfoId: '',
        empIssueInfoTopic: '',
        empIssueInfoDetail: '',
        empCode: this.$session.getAll().data.empCode,
        userName: '',
        STATUS: ''
      },
      formUpdateItem: {
        empIssueInfoId: '',
        empIssueInfoTopic: '',
        empIssueInfoDetail: '',
        empCode: '',
        userName: '',
        STATUS: ''
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      empIssueInfoId: '',
      dataEmp: ''
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    // await this.getData()
  },
  filters: {
    moment: function (date) {
      return moment(date).locale('th').add(543, 'year').format('LL')
    }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      this.dataInfo = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            this.path +
            'getEmpCode?empCode=' +
            this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['RECORD_STATUS']
            this.dataInfo = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function SubmitDataById : ', error)
        })
    },
    async addData () {
      var emp = JSON.parse(localStorage.getItem('data'))
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = emp.userName
      this.formAdd.LAST_USER = emp.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = emp.empCode
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

      // console.log('form', JSON.stringify(this.formAdd))

      this.dataReady = false
      this.addDataSubmit()
    },
    async addDataSubmit () {
      // console.log(this.formAdd)
      this.$swal({
        title: 'ต้องการ แจ้งปัญหาข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (response) => {
          delete this.formAdd['empIssueInfoId']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.dataReady = true
                this.linenotify(this.formAdd)
                this.SubmitDataById()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async approveData (d) {
      var emp = JSON.parse(localStorage.getItem('data'))
      this.$swal({
        title: 'ท่านได้ดำเนินการแล้ว ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let ds = {
          LAST_USER: emp.userName
        }

        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + this.path + "approve/" + d.empIssueInfoId,
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            // console.log('editDataGlobal DNS_IP + PATH + edit/', response)
            this.$swal('เรียบร้อย', 'ลบข้อมูล เรียบร้อย', 'success')
            this.SubmitDataById()
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      })
      // console.log(this.datalistFrame)
    },
    async linenotify (dt) {
      var emp = JSON.parse(localStorage.getItem('dataByHR'))
      var text = {
        message: `[${emp.empCode}] ${emp.empFull_NameTH}\n\nหัวข้อแจ้งปัญหา : ${dt.empIssueInfoTopic}\n\nรายละเอียดแจ้งปัญหา :  ${dt.empIssueInfoDetail} \n\n\n https://liff.line.me/1654154168-M2EgzyY2?empCode=${emp.empCode}`
      }

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/notify",
          text
        )
        .then(async (response) => {
          // console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('linenotify: ', error)
        })
    }
  }
}
</script>
<style scope>
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/ManualApp.vue